import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";

const fmtPrice = (p) => (p && p > 0 ? `€${p}` : "—");

export const Prices = () => {
  const { content } = useContent();
  const navigate = useNavigate();
  const { t, L } = useLang();
  const prices = content?.prices || {};
  const items = prices.items || [];

  return (
    <section id="prices" className="bg-sand-200 py-20 sm:py-28" data-testid="prices-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-6">
        <div className="text-center mb-14">
          <p className="eyebrow text-coral mb-4">{t("prices.eyebrow")}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-ocean leading-[1.05]">
            {t("prices.title")}
          </h2>
          <p className="text-ocean/60 mt-4 max-w-xl mx-auto">{L(prices.note)}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-2xl border border-ocean/10 overflow-hidden shadow-sm"
        >
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`price-row-${i}`}
              className="flex items-center justify-between gap-4 px-5 sm:px-8 py-5 border-b border-ocean/5 last:border-0 hover:bg-sand-100 transition-colors"
            >
              <div>
                <div className="font-heading font-bold text-ocean text-base sm:text-lg">{L(it.name)}</div>
                <div className="text-sm text-ocean/50">{L(it.description)}</div>
              </div>
              <div className="text-right shrink-0">
                <span className="font-heading text-2xl font-extrabold text-ocean">{fmtPrice(it.price)}</span>
                <span className="font-mono text-xs text-ocean/50 block">{L(it.unit)}</span>
              </div>
            </div>
          ))}
        </motion.div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate("/book")}
            data-testid="prices-book-button"
            className="inline-flex items-center gap-2 bg-ocean hover:bg-ocean-700 text-sand-100 font-heading font-bold px-8 py-4 rounded-full transition-all hover:scale-[1.03]"
          >
            {t("prices.book")}
          </button>
        </div>
      </div>
    </section>
  );
};
